function Error() {
  return (
    <div className="flex flex-1 justify-center items-center text-bold font-semibold text-white text-3xl text-center mx-auto bg-gradient-to-r from-pure-greys-700 to-pure-greys-900 h-[100vh]">
      Error 404 - Page Not Found
    </div>
  );
}

export default Error;
